export default __webpack_public_path__ + "static/media/small.2f83fa19.jpg";